import "antd/es/switch/style";
import _Switch from "antd/es/switch";
import withFieldWrap from '../../utils/withFieldWrap';
export default withFieldWrap(_Switch);